import { gql } from '@apollo/client';

const noUpdateDashboardItemFields = `
    fragment NoUpdateDashboardItemFields on NoUpdateDashboardItemType {
        timePeriod
        hubId
        sortingCode
        linehaulInboundCount
        inHubOperationCount
        inHubLinehaulCount
        lastMileCount
        lastMileAtWhsCount
        lastMileAtDspCount
        linehaulInboundParcelCount
        inHubOperationParcelCount
        inHubLinehaulParcelCount
        lastMileParcelCount
        inHubNoUpdateCount
        inHubParcelCount
        totalNoUpdateCount
        totalParcelCount
        totalNoUpdateRate
        inHubNoUpdateRate
        linehaulInboundRate
        inHubOperationRate
        inHubLinehaulRate
        lastMileRate
        lastMileAtWhsRate
        lastMileAtDspRate
        lastMileByResponsibleWhs {
            responsibleWarehouseId
            sortingCode
            count
            rate
            parcelCount
        }
        inHubLinehaulByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
        linehaulInboundByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
        inHubOperationByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
    }
`;

const noUpdateDashboardAggregateFields = `
    fragment NoUpdateDashboardAggregateFields on NoUpdateDashboardAggregateItemType {
        hubId
        sortingCode
        linehaulInboundCount
        inHubOperationCount
        inHubLinehaulCount
        lastMileCount
        lastMileAtWhsCount
        lastMileAtDspCount
        linehaulInboundParcelCount
        inHubOperationParcelCount
        inHubLinehaulParcelCount
        lastMileParcelCount
        inHubNoUpdateCount
        inHubParcelCount
        totalNoUpdateCount
        totalParcelCount
        totalNoUpdateRate
        inHubNoUpdateRate
        linehaulInboundRate
        inHubOperationRate
        inHubLinehaulRate
        lastMileRate
        lastMileAtWhsRate
        lastMileAtDspRate
        lastMileByResponsibleWhs {
            responsibleWarehouseId
            sortingCode
            count
            rate
            parcelCount
        }
        inHubLinehaulByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
        linehaulInboundByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
        inHubOperationByResponsibleHub {
            responsibleHubId
            sortingCode
            count
            rate
            parcelCount
        }
    }
`;

export const QUERY_QUALITY_DASHBOARD = gql`
    ${noUpdateDashboardItemFields}
    ${noUpdateDashboardAggregateFields}
    query QueryQualityDashboard($input: NoUpdateDashboardQueryInput!) {
        queryQualityDashboard(input: $input) {
            items {
                ...NoUpdateDashboardItemFields
            }
            aggregate {
                ...NoUpdateDashboardAggregateFields
            }
            latestCalculatedAt
        }
    }
`;
